import api from './api'
import { WorkCenter, WorkCentersListResponse, WorkCenterType, ApiResponse } from '../types'

export interface WorkCenterFilters {
  type?: WorkCenterType
  isActive?: boolean
  search?: string
}

export interface CreateWorkCenterData {
  type: WorkCenterType
  name: string
  fixedStaff: number
  maxConcurrent?: number
  maxPerPosition?: number
  maxPerDay: number
  isActive?: boolean
}

export interface UpdateWorkCenterData {
  name?: string
  fixedStaff?: number
  maxConcurrent?: number
  maxPerPosition?: number
  maxPerDay?: number
  isActive?: boolean
}

export const workCenterService = {
  async getAll(filters?: WorkCenterFilters): Promise<WorkCentersListResponse> {
    const params = new URLSearchParams()
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          params.append(key, String(value))
        }
      })
    }
    const response = await api.get<ApiResponse<WorkCentersListResponse>>(
      `/configuration/work-centers?${params.toString()}`
    )
    return response.data.data
  },

  async getActive(): Promise<WorkCenter[]> {
    const response = await api.get<ApiResponse<WorkCenter[]>>(
      '/configuration/work-centers/active'
    )
    return response.data.data
  },

  async getById(id: string): Promise<WorkCenter> {
    const response = await api.get<ApiResponse<WorkCenter>>(`/configuration/work-centers/${id}`)
    return response.data.data
  },

  async create(data: CreateWorkCenterData): Promise<WorkCenter> {
    const response = await api.post<ApiResponse<WorkCenter>>('/configuration/work-centers', data)
    return response.data.data
  },

  async update(id: string, data: UpdateWorkCenterData): Promise<WorkCenter> {
    const response = await api.put<ApiResponse<WorkCenter>>(`/configuration/work-centers/${id}`, data)
    return response.data.data
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/configuration/work-centers/${id}`)
  },

  async toggleActive(id: string): Promise<WorkCenter> {
    const response = await api.patch<ApiResponse<WorkCenter>>(`/configuration/work-centers/${id}/toggle`)
    return response.data.data
  },

  async seedDefaults(): Promise<{ created: number }> {
    const response = await api.post<ApiResponse<{ created: number }>>('/configuration/work-centers/seed')
    return response.data.data
  },
}
